<app-login-base pageHeader="Sign up">

                    <form class="text-center p-3 w-100" (ngSubmit)="SignUp()" *ngIf="!showSuccess">                        
                        <div class="row">
                            <div class="col">
                                <!-- First name -->
                                <div class="md-form input-white">
                                    <div class="input-group">
                                        <input [(ngModel)]="signUp.firstName" mdbInput mdbValidate name="firstName" type="text" id="firstName" class="form-control auto-bottom-margin" #firstName="ngModel" required >
                                        <label for="firstName">First name</label>
                                        <mdb-error *ngIf="firstName.invalid && (firstName.dirty || firstName.touched)">First name is required</mdb-error>
                                        <mdb-success *ngIf="firstName.valid && (firstName.dirty || firstName.touched)"></mdb-success>
                                    </div>
                                </div>
                            </div>
                            <div class="col">
                                <!-- Last name -->
                                <div  class="md-form input-white">
                                    <div class="input-group">
                                        <input [(ngModel)]="signUp.lastName" mdbInput mdbValidate name="lastName" type="text" id="lastName" class="form-control auto-bottom-margin" #lastName="ngModel" required >
                                        <label for="lastName">Last name</label>
                                        <mdb-error *ngIf="lastName.invalid && (lastName.dirty || lastName.touched)">Last name is required</mdb-error>
                                        <mdb-success *ngIf="lastName.valid && (lastName.dirty || lastName.touched)"></mdb-success>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!-- E-mail -->
                        <div  class="md-form input-white" style="margin-top: 5px;">
                            <div class="input-group">
                                <input [(ngModel)]="signUp.email" mdbInput mdbValidate name="email" type="text" id="email" class="form-control auto-bottom-margin" #email="ngModel" required [pattern]="emailRegExpression">
                                <label for="email">E-mail</label>
                                <mdb-error *ngIf="email.invalid && (email.dirty || email.touched)">Email address not valid</mdb-error>
                                <mdb-success *ngIf="email.valid && (email.dirty || email.touched)"></mdb-success>
                            </div>
                        </div>

                        <!--Password -->
                        <div class="md-form input-white">
                            <div class="input-group">
                                <input [(ngModel)]="signUp.password" mdbInput mdbValidate name="password" type="password" id="form7" class="form-control auto-bottom-margin" #password="ngModel" required [pattern]="'^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9]).{8,}$'">
                                <label for="form7">Password</label>
                                <mdb-error *ngIf="password.invalid && (password.dirty || password.touched)">At lease 8 characters including a number and a uppercase letter</mdb-error>
                                <mdb-success *ngIf="password.valid && (password.dirty || password.touched)"></mdb-success>
                            </div>
                        </div>

                        <!--Confirm Password -->
                        <div class="md-form input-white">
                            <div class="input-group">
                                <input [(ngModel)]="signUp.confirmPassword" mdbInput mdbValidate name="confirmPassword" type="password" id="form8" class="form-control auto-bottom-margin" #confirmPassword="ngModel" required [pattern]="'^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9]).{8,}$'">
                                <label for="form8">Confirm password</label>
                                <mdb-error *ngIf="confirmPassword.invalid && (confirmPassword.dirty || confirmPassword.touched)">At lease 8 characters including a number and a uppercase letter</mdb-error>
                                <mdb-success *ngIf="confirmPassword.valid && (confirmPassword.dirty || confirmPassword.touched)"></mdb-success>
                            </div>
                        </div>

                        <!-- Phone number -->
                        <!-- <div class="md-form">
                            <input [(ngModel)]="signUp.mobile" name="mobile" type="text" id="materialRegisterFormPhone"
                                class="form-control" aria-describedby="materialRegisterFormPhoneHelpBlock" mdbInput>
                            <label for="materialRegisterFormPhone">Phone number</label>
                            <small id="materialRegisterFormPhoneHelpBlock" class="form-text text-muted mb-4">
                                Optional - for two-step authentication
                            </small>
                        </div> -->

                        <!--Error Display-->
                        <div class="col">
                            <div *ngIf="showError" class="alert alert-danger" role="alert">
                                {{errorMsg}}
                            </div>
                        </div>

                        <div class="d-flex justify-content-around">
                            <div class="col-sm-10 col-md-8">
                            <button *ngIf="!busy" mdbBtn color="dooya" block="true" class="my-4" type="submit">Sign up</button>                            
                            <app-loading [busy]="busy"></app-loading>
                            </div>
                        </div>                            
                    </form>
                    <form class="text-center p-3 w-100" *ngIf="showSuccess">                        
                        <div class="col">
                            <div *ngIf="showSuccess" class="alert alert-success" role="alert">
                                Registration successful! A confirmation email has been sent to you.
                            </div>
                        </div>

                        <div class="col">
                            <div class="d-flex justify-content-around">
                                <div>
                                    <!-- Forgot password -->
                                    <a href="/login">Back to Login</a>
                                </div>
                            </div>
                        </div>
                        <app-loading [busy]="busy"></app-loading>
                        <hr>
                    </form>     
                                          
                        <small>By clicking <em>Sign up</em> you agree to Dooya's</small>        
 </app-login-base>